export default "__VITE_ASSET__Z8xWb8KK__"